<template>
  <div id="wealth-management" class="header-gap bo">
    <div class="sub-banner">
      <div class="container">
        <h1 v-html="$t('wealth-management.banner-title')"></h1>
        <p v-html="$t('wealth-management.banner-desc')"></p>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="column">
          <h2>{{$t("wealth-management.doo-wealth")}}</h2>
          <p><i></i> {{$t("wealth-management.doo-wealth-desc")}}</p>
          <a href="https://www.doowealth.com/" target="_blank" v-t="'business-overview.learn-more'"></a>
        </div>
        <div>
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/business_overview/wealthManagement_image1.png" />
        </div>
      </div>
    </div>

    <BOContactUs bocontent="wealth-management"/>
  </div>
  <Modals />
</template>
  
<script setup>
  import "../less/style.css"
  import Modals from '@/components/Modals/ModalMain.vue'
  import BOContactUs from '@/components/BOContactUs.vue'

  import { useHead } from '@unhead/vue'
  import { useI18n } from 'vue-i18n'
  import { computed, onMounted } from 'vue'
  import { decodeHtml } from '@/utils'

  const { t } = useI18n()

  useHead({
    title: computed(() => decodeHtml(t('seo.wealthmanagement.title'))),
    meta: [
      { name: 'description', content: computed(() => t('seo.wealthmanagement.description')) },
      { name: 'keywords', content: computed(() => t('seo.wealthmanagement.keywords')) },
    ],
  })

  onMounted(() => {
    if (typeof document !== 'undefined')
      document.dispatchEvent(new Event('prerender-ready'))
  })

</script>

<style lang="less">
  @import '../less/mediaQuery.less';

  #wealth-management {
    .sub-banner {
      background:url('https://cdn.dootech.io/doo/business_overview/banner_wealthManagement.png') no-repeat center top;
      @media @mobile-screen {
        background:url('https://cdn.dootech.io/doo/business_overview/banner_wealthManagement_mobile.png') no-repeat center top;
      }
      .container {
        @media only screen and (max-width:1500px) and (min-width:835px) {
          max-width: 40%;
          margin: 0;
        }
      }
    }
    @media only screen and (max-width:1400px) and (min-width:951px) {
      .container {
        padding:0 32px;
      }
    }
  }
</style>
